import { Component, ViewChild, ElementRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem } from '@angular/cdk/drag-drop';
import { GlobalService } from 'src/app/Services/global.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ImageCroppedEvent, LoadedImage ,Dimensions,ImageTransform} from "ngx-image-cropper";
import { getLocalJSON } from '../../_helpers/storage.util';


declare var $: any;

@Component({
  selector: 'app-createalbums',
  templateUrl: './createalbums.component.html',
  styleUrls: ['./createalbums.component.scss']
})
export class CreatealbumsComponent {

  public loading: boolean = false;
  public submitted: boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public message: any;
  public AlbumData: any = [];
  public AddAlbumData: any = [{}];
  public currentUrl: any = this.router.url;
  public dataDetail: any = [];
  public cdkView: boolean = false;
  public showView: boolean = true;
  public search: any = '';
  public status: any = '';
  public loginDetail: any = [];
  public showSearch: boolean = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImage1: any = "";
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  allowMoveImage = false;
  hidden = false;


  public albumType:any='';
  public demographicList:any=[];
  public LevelLIst:any=[];
  public dietList:any=[];
  public TypeList:any=[];
  public allmasterData:any={};
  public primaryList:any=[];
  public dropdownSettings: IDropdownSettings;
  public typeSelected:any=[];
  public typename:any='';
  public categorySelected:any=[];
  public categoryname:any='';
  public genderList:any=[];
  public sprimaryList:any=[];
  public scategorySelected:any=[];
  public scategoryname:any='';
  public d_otherSelection:any='';
  public t_otherSelection:any='';
  public s_otherSelection:any='';

  albumData = new FormGroup({
    albumName: new FormControl('', Validators.compose([
      Validators.required, Validators.maxLength(35)])),
    types: new FormControl('', Validators.compose([
      Validators.required])),
    description: new FormControl('', Validators.compose([
      Validators.required, Validators.maxLength(140)])),
    demographic:new FormControl('',Validators.compose([
      Validators.required])), 
    level:new FormControl(''),
    diet:new FormControl(''), 
    type:new FormControl(''),
    category:new FormControl(''),    
    gender:new FormControl(''),    
    d_others:new FormControl(''),
    s_others:new FormControl(''),
    t_others:new FormControl(''),  
    scategory:new FormControl(''),
  })

  get f() { return this.albumData.controls; }

  constructor(private sanitizer: DomSanitizer, private el: ElementRef, public router: Router, public service: GlobalService) {
    this.getAllMasterData();
    this.loginDetail = getLocalJSON('grw_login');
    if (this.currentUrl == '/edit-albums') {
      var js = getLocalJSON('grw_album')
      this.albumType=js.category_type;
      this.getDetail();
    } else {
      this.dataDetail.gender='';
    }
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      limitSelection: 3,
    };
  }

  getDetail() {
    var ss:any='';
    this.loading = true;
    if(this.albumType ==3){
      ss='';
    } else {
      ss= '?category_type=' +this.albumType;
    }
    const url = "/video-list-for-album"+ss;
    var detail: any = {
      "search": this.search,
    }
    this.service.PostApis(detail, url).subscribe(((response: any) => {
      if (response.success == 1) {
        this.AlbumData = response.data;       
      } else {
        this.AlbumData = [];
        this.cdkView = true;
      }
      if (this.currentUrl == '/edit-albums') {
        this.getalbumDetail();
      } else {
        this.cdkView = true;
      }
      this.loading = false;
    }), (error) => { this.loading = false; });
  }

  drop(event: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      let idx = 1;
      if (this.AddAlbumData.length != 0) {
        this.AddAlbumData.filter((el: any) => {
          if (el._id == undefined) {
            return;
          }
          if (el._id == event.previousContainer.data[event.previousIndex]._id) {
            idx = 0;
          }
        })
      }

      // let idx=event.container.data.indexOf(event.previousContainer.data[event.previousIndex]);
      // if(idx != -1){
      //   return;
      // }
      if (idx == 0) {
        return;
      }
      var jj: any = [], count = 0;
      if (event.previousContainer.data[0]._id != undefined && event.previousContainer.data[0]._id != null) {
        copyArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }

      // transferArrayItem(
      //   event.previousContainer.data,
      //   event.container.data,
      //   event.previousIndex,
      //   event.currentIndex,
      // );
      if (event.previousContainer.data) {
        this.AlbumData = this.AlbumData.filter((f: any) => !f.temp);
      }
      if (this.AddAlbumData.length != 0) {
        this.AddAlbumData.filter((el: any) => {
          if (el._id == undefined) {
          } else {
            jj.push(el);
          }
        })
        if (jj.length != 0) {
          this.AddAlbumData = jj;
        } else {
          this.AddAlbumData = [{}];
        }
      } else {
        this.AddAlbumData = [{}];
      }
    }
  }

  exited1(id: any) {
    var mm = this.AddAlbumData;
    var ss: any = [];

    mm.filter((el: any) => {
      if (el._id != id) {
        ss.push(el);
      }
    })
    if (ss.length == 0) {
      this.AddAlbumData = [{}];
    } else {
      this.AddAlbumData = ss;
    }


    // const currentIdx = id
    // event.container.data.findIndex(
    //   (f: any) => f.id === event.item.data.id
    // );
    // this.AddAlbumData.splice(currentIdx + 1, 0, {
    //   ...event.item.data,
    //   temp: true,
    // });
  }

  exited(event: any) {
    const currentidx = event.container.data.findindex(
      (f: any) => f.id === event.item.data.id
    );
    this.AlbumData.splice(currentidx + 1, 0, {
      ...event.item.data,
      temp: true,
    });
  }
  entered() {
    this.AlbumData = this.AlbumData.filter((f: any) => !f.temp);
  }

  Onsubmit(type: any) {
    this.loading = true;
    var url = "";
    let formdata = new FormData();
    this.submitted = true;
    let userdetail: any = this.albumData;
    if (this.croppedImage == '') {
      this.service.dangerAlert('Cover Image is Required');
      this.loading = false;
      return
    } else {
      if (this.croppedImage1 != "") {
        const fileObject = this.service.dataURLtoFile(
          this.croppedImage1,
          "post.png"
        );
        formdata.append("album_image", fileObject);
      }
    }
    var kk: any = []; var count = 1, freecount=0;
    this.AddAlbumData.filter((el: any) => {
      if (el._id == undefined) {
      } else {
        kk.push({ "video_id": el._id, "order": count });
        count = count + 1;
      }
      if( el.is_content_free ==true)  {
        freecount =1;
      } 
    })
    if (kk.length == 0) {
      this.service.dangerAlert('Please Upload Video To Create Album');
      this.loading = false;
      return;
    }
    // if (freecount == 0) {
    //   this.service.dangerAlert('Please Upload A Free Video To Create Album');
    //   this.loading = false;
    //   return;
    // }
    if (userdetail.valid) {
      if(userdetail.value.level == undefined){
        userdetail.value.level='';
      }
      if(userdetail.value.gender == undefined){
        userdetail.value.gender='';
      }
      if (type == 1) {
        this.showView = true;
        this.loading = false;
        window.scroll(0, 0);
      } else {
        if (this.currentUrl == '/edit-albums') {
          url = '/album-update';
          formdata.append('album_id', this.dataDetail._id);
          formdata.append('status', this.status);
        } else {
          url = "/album";
        }
        // formdata.append('album_image',this.selectedFile);
        formdata.append('name', userdetail.value.albumName);
        formdata.append('gender', userdetail.value.gender);
        formdata.append('description', userdetail.value.description);
        formdata.append('videos', JSON.stringify(kk));
        formdata.append('category_type',this.albumType);
        formdata.append('demographic',userdetail.value.demographic);
        if(this.albumType==1){
          formdata.append('levels',userdetail.value.level);
          formdata.append('types',this.typename); 
          formdata.append('type_other',userdetail.value.t_others); 
        }
        if(this.albumType==2){
          formdata.append('diets',userdetail.value.diet);
          formdata.append('categories',this.categoryname); 
          formdata.append('sub_categories',this.scategoryname);
          formdata.append('diet_other',userdetail.value.d_others);
          formdata.append('sub_category_other',userdetail.value.s_others);
        }
        if(this.albumType==3){
          formdata.append('levels',userdetail.value.level);
          formdata.append('diets',userdetail.value.diet);
          formdata.append('types',this.typename);   
          formdata.append('categories',this.categoryname);
          formdata.append('sub_categories',this.scategoryname);
            formdata.append('type_other',userdetail.value.t_others);
            formdata.append('diet_other',userdetail.value.d_others); 
            formdata.append('sub_category_other',userdetail.value.s_others);   
        }
        this.service.PostApiFormData(formdata, url).subscribe(((response: any) => {
          if (response.success == 1) {
            this.submitted = false;
            this.loading = false;
            if (localStorage.getItem('grw_albumTrue')) {
              this.loginDetail.album = true;
              localStorage.setItem('grw_login', <any>JSON.stringify(this.loginDetail));
              this.service.setSubject(response.data);
              localStorage.removeItem('grw_albumTrue');
            }
            this.router.navigate(['/albums']);
          } else {
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        }), (error: any) => {
        });
      }

    } else {
      const invalidControls: string[] = [];
      Object.keys(userdetail.controls).forEach((controlName) => {
        const control = userdetail.get(controlName);
        if (control && control.invalid) {
          invalidControls.push(controlName);
        }
      });
      if(invalidControls.length >1){
        this.service.dangerAlert('Please complete mandatory sections.');
      } else {
        var ss='';
        if(invalidControls[0]=='albumName'){
          ss='Title';
        }
        else if(invalidControls[0]=='types'){
          ss='Product';
        }
        else if(invalidControls[0]=='scategory'){
          ss='Sub category';
        }
       else if(invalidControls[0]=='d_others'){
        ss='Diet Other';
      }
      else if(invalidControls[0]=='t_others'){
        ss='Type Other';
      } else if(invalidControls[0]=='description'){
        ss='Description';
      } else {
        ss=invalidControls[0];
      }
        this.service.dangerAlert(ss +' is required.');
      }
      this.loading = false;
      userdetail.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }

  getUploadFileDetail(event: any) {
    this.selectedFile = event[0];
    var mimeType = event[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    this.imagePath = event;
    reader.readAsDataURL(event[0]);
    reader.onload = (_event: any) => {
      const image = new Image();
      image.src = _event.target.result;
      image.onload = () => {
        const {
          height,
          width
        } = image;
        // if (height < 1080 || width < 1920) {
        //   this.service.dangerAlert("Image should be at least 1920px by 1080px.");
        //   return false;
        // }
        this.imgURL = reader.result;
        return true;
      };
    }
  }

  changeImage(file: any) {
    var mm = "#" + file;
    $(mm).trigger("click");
  }

  changeImage1(event: any) {
    this.imageChangedEvent = event;
    this.getUploadFileDetail(event.target.files);
  }

  delete() {
    const url = "/album-delete?album_id=" + localStorage.getItem('grw_album_id');
    this.service.DeleteApi(url).subscribe(((response: any) => {
      if (response.success == 1) {
        $('#DeletePopup1').modal('toggle');
        this.router.navigate(['/albums']);
      }
    }), (error) => { this.loading = false; });
  }

  getalbumDetail() {
    const url = "/album-detail?album_id=" + localStorage.getItem('grw_album_id');
    this.service.GetApi(url).subscribe(((response: any) => {
      if (response.success == 1) {
        var self=this;
        if(response.data.status=='Published'){
          this.status=1;
        } else {
          if(response.data.status=='Unpublished'){
            this.status=2;
          }
        }
        
        this.imgURL = response.data.album_image;
        this.croppedImage= response.data.album_image;
        this.albumData.controls["types"].setValue(response.data.category_type);
        if(response.data.demographic_info.length != 0){
          response.data.demographic = response.data.demographic_info[0]._id;
        }
        if(response.data.levels_info.length != 0){
          response.data.level = response.data.levels_info[0]._id;
        }
        if(response.data.gender.length != 0){
          response.data.gender = response.data.gender[0]._id;
        }
        if(response.data.type_info.length != 0){
          var ss:any=[];
          response.data.type_info.filter((el:any)=>{
            ss.push(el)
         })
          self.typeSelected=ss;
        }
        if(response.data.diets_info.length != 0){
          response.data.diet = response.data.diets_info[0]._id;
          if(response.data.diets_info[0].childContent){
            self.d_otherSelection=response.data.diets_info[0]._id;
          }
        }
        if(response.data.categories_info.length != 0){
          var mm:any=[];
          response.data.categories_info.filter((el:any)=>{
           mm.push (el);
          })
          self.categorySelected=mm;
        }
        if(response.data.sub_category_info.length != 0){
          var mm1:any=[];
          response.data.sub_category_info.filter((el:any)=>{
           mm1.push (el);
          })
          self.scategorySelected=mm1;
        }
        this.dataDetail = response.data;
        var kk: any = this.AlbumData;
        this.AddAlbumData = [];
        var self = this;
        kk.filter((el: any) => {
          var count = 0;
          response.data.album_videos.filter((ell: any) => {
            if (el._id == ell._id) {             
              count = count + 1;
            }
          })
          if (count != 0) {
            self.AddAlbumData.push(el);
          }
        })
        setTimeout(() => {
          this.cdkView = true;
        }, 200)
      }
    }), (error) => { this.loading = false; });
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  // From drag and drop
  onDropSuccess(event: any): void {
    this.imageChangedEvent = event;
    event.preventDefault();
    this.getUploadFileDetail(event.dataTransfer.files);    // notice the "dataTransfer" used instead of "target"
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    console.log(event);
  }

  imageCropped1(event: any) {
    var reader = new FileReader();
    reader.readAsDataURL(event.blob);
    const self = this;
    reader.onloadend = function () {
      var base64data = reader.result;
      self.croppedImage1 = base64data;
    }
    console.log(self.croppedImage1);
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

   cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    // show message
  }

  setCheckval(event:any){
    this.albumType =event.value;
    if(this.albumType==1){    
      this.d_otherSelection=''; 
      this.albumData.controls["d_others"].setValue('');
      this.albumData.controls["type"].setValidators([Validators.required]);
      this.albumData.controls["type"].updateValueAndValidity();
      this.albumData.controls["type"].setValue('');
      this.albumData.controls["diet"].removeValidators([Validators.required]);
      this.albumData.controls["diet"].updateValueAndValidity();
      this.albumData.controls["diet"].setValue('');
      // this.albumData.controls["category"].removeValidators([Validators.required]);
      // this.albumData.controls["category"].updateValueAndValidity();
      // this.albumData.controls["category"].setValue('');
      this.albumData.controls["scategory"].removeValidators([Validators.required]);
      this.albumData.controls["scategory"].updateValueAndValidity();
      this.albumData.controls["scategory"].setValue('');
    } else  if(this.albumType==2){
      this.t_otherSelection=''; 
      this.albumData.controls["t_others"].setValue('');
      this.albumData.controls["diet"].setValidators([Validators.required]);
      this.albumData.controls["diet"].updateValueAndValidity();
      this.albumData.controls["diet"].setValue('');
      // this.albumData.controls["category"].setValidators([Validators.required]);
      // this.albumData.controls["category"].updateValueAndValidity();
      // this.albumData.controls["category"].setValue('');
      this.albumData.controls["scategory"].setValidators([Validators.required]);
      this.albumData.controls["scategory"].updateValueAndValidity();
      this.albumData.controls["scategory"].setValue('');
      this.albumData.controls["type"].removeValidators([Validators.required]);
      this.albumData.controls["type"].updateValueAndValidity();
      this.albumData.controls["type"].setValue('');
    } else {
      this.albumData.controls["diet"].setValidators([Validators.required]);
      this.albumData.controls["diet"].updateValueAndValidity();
      this.albumData.controls["diet"].setValue('');
      // this.albumData.controls["category"].setValidators([Validators.required]);
      // this.albumData.controls["category"].updateValueAndValidity();
      // this.albumData.controls["category"].setValue('');
      this.albumData.controls["scategory"].setValidators([Validators.required]);
      this.albumData.controls["scategory"].updateValueAndValidity();
      this.albumData.controls["scategory"].setValue('');
      this.albumData.controls["type"].setValidators([Validators.required]);
      this.albumData.controls["type"].updateValueAndValidity();
      this.albumData.controls["type"].setValue('');
    }
    this.AddAlbumData = [{}];
    this.getDetail();
  }


  updateStatus(){
    var url="/album-update-status?album_id=" +localStorage.getItem('grw_album_id');
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success){
        this.service.successAlert(response.message);  
        this.getalbumDetail();    
      } else {
        this.service.dangerAlert(response.message);   
      }
    }))
    }

    getAllMasterData(){  
      var self=this,ss:any=[],dd:any=[];
      const url = "/common-contents"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
      this.allmasterData=response.data; 
      this.allmasterData.type.filter((el:any)=>{
        if(el.childContent==false){
          ss.push(el);
        } else {
          dd=el;
        }
        el.chcecked = false;
      });
      ss.push(dd);
      this.allmasterData.type =ss;
      ss=[],dd=[];
      this.allmasterData.sub_category.filter((el:any)=>{
        if(el.childContent==false){
          ss.push(el);
        } else {
          dd=el;
        }
        el.chcecked = false;
      });
      ss.push(dd);
      this.allmasterData.sub_category =ss;
      ss=[],dd=[];
      this.allmasterData.diet.filter((el:any)=>{
        if(el.childContent==false){
          ss.push(el);
        } else {
          dd=el;
        }
        el.chcecked = false;
      })
      ss.push(dd);
      this.allmasterData.diet =ss;
      ss=[],dd=[];     
      this.sprimaryList = this.allmasterData.sub_category;  
      this.primaryList = this.allmasterData.primary_category;   
      this.demographicList =this.allmasterData.demographic;
      this.LevelLIst = this.allmasterData.levels;
      this.dietList = this.allmasterData.diet; 
      this.TypeList = this.allmasterData.type; 
      // this.allmasterData.genders.filter((el:any)=>{
      //   if(el.name!='Other' && el.name!='other'){
      //     ss.push(el);
      //   } else {
      //     dd=el;
      //   }
      //   el.chcecked = false;
      // })
      // ss.push(dd);
      // this.allmasterData.genders =ss;
      ss=[],dd=[];
      this.genderList = this.allmasterData.genders;
    }
  }), (error) => { this.loading =false; });
    }

    onFilterChange(event: any, type: any) {
      if (type == 1) {
      } else if (type == 2) {
      } else if (type == 3) {
      } else if (type == 4) {
      } else {
      }
      console.log(event);
    }
  
    changeSelection(type:any) {
      var subcatText: any='',self=this,count=0;
      if(type==1){
        if (this.typeSelected.length != 0) {
          this.typeSelected.filter(function (ell: any) {          
            if (subcatText) {
              subcatText = ell._id + " , " + subcatText;
            } else {
              subcatText = ell._id;
            }      
          });
          if(subcatText !=''){
            this.typename= subcatText;
          }
          this.typeSelected.filter(function (ell: any) {
            self.TypeList.filter((el:any)=>{
              if(ell._id ==el._id && el.childContent==true){
                count=1;
              }            
            })               
          });
          if(count==1){
            self.t_otherSelection ='123344';
            self.albumData.controls["t_others"].setValidators([Validators.required]);
            self.albumData.controls["t_others"].updateValueAndValidity();
            // self.albumData.controls["t_others"].setValue('');
          } else {
            self.t_otherSelection ='';
            self.albumData.controls["t_others"].removeValidators([Validators.required]);
            self.albumData.controls["t_others"].updateValueAndValidity();
            self.albumData.controls["t_others"].setValue('');
          }
        }
      } else if(type==2){
        if (this.categorySelected.length != 0) {
          this.categorySelected.filter(function (el: any) {
            if (subcatText) {
              subcatText = el._id + " , " + subcatText;
            } else {
              subcatText = el._id;
            }       
          });        
          if(subcatText !=''){
            this.categoryname= subcatText;
          }
        } else {
          this.categoryname='';

        }
      } else{
        if (this.scategorySelected.length != 0) {        
          this.scategorySelected.filter(function (ell: any) {         
            if (subcatText) {
              subcatText = ell._id + " , " + subcatText;
            } else {
              subcatText = ell._id;
            }       
          });        
          if(subcatText !=''){
            this.scategoryname= subcatText;
          }
          this.scategorySelected.filter(function (ell: any) {
            self.sprimaryList.filter((el:any)=>{
              if(ell._id ==el._id && el.childContent==true){
               count=1
              }             
            })                 
          }); 
          if(count==1){
            self.s_otherSelection ='123344';
            self.albumData.controls["s_others"].setValidators([Validators.required]);
            self.albumData.controls["s_others"].updateValueAndValidity();
            self.albumData.controls["s_others"].setValue('');
          } else {
            self.s_otherSelection ='';
            self.albumData.controls["s_others"].removeValidators([Validators.required]);
            self.albumData.controls["s_others"].updateValueAndValidity();
            self.albumData.controls["s_others"].setValue('');
          }
        }
      }
  
    }

    getCheckboxexData(event:any){
      var self=this;
        this.dietList.filter((el:any)=>{
            if(event.value ==el._id && el.childContent==true){
              self.d_otherSelection =el._id;
              self.albumData.controls["d_others"].setValidators([Validators.required]);
              self.albumData.controls["d_others"].updateValueAndValidity();
              // self.albumData.controls["d_others"].setValue('');
            } 
            if(event.value ==el._id && el.childContent==false){
              self.d_otherSelection ='';
              self.albumData.controls["d_others"].removeValidators([Validators.required]);
              self.albumData.controls["d_others"].updateValueAndValidity();
              self.albumData.controls["d_others"].setValue('');
            } 
            if(el._id == event.value){
              el.chcecked = true;
            } else {
              el.chcecked = false;
            }                 
        })   
    }

    getChaecks(event:any){
      var self=this;
      this.genderList.filter((el:any)=>{
        if(el._id == event.target.id){
          if(el.chcecked==true){
            $("#"+event.target.id).prop("checked", false); 
            el.chcecked=false;
            self.albumData.controls['gender'].setValue('');
          } else {
            $("#"+event.target.id).prop("checked", true); 
            el.chcecked=true;

          }
        } else {
          el.checked=false;
        }
      })
    }
}
